import { a3Copy } from "@/components/assignments/a3-copy";
import type { ArtifactUploadPolicy } from "@/lib/api/assignments";

/** Mirrors the server's figure so the refusal reads the same before and after reservation. */
export function megabytes(bytes: number): string {
  const value = bytes / (1024 * 1024);
  return value >= 10 || Number.isInteger(value) ? value.toFixed(0) : value.toFixed(1);
}

export function uploadLimits(policy: ArtifactUploadPolicy): string {
  return a3Copy.imamAcceptsUpTo(policy.summary, megabytes(policy.max_bytes));
}

/** The file picker offers the tenant's types; the precheck below still decides. */
export function acceptAttribute(policy: ArtifactUploadPolicy | null | undefined): string | undefined {
  if (!policy) return undefined;
  return [...new Set(policy.types.flatMap(entry => [...entry.extensions, entry.content_type]))].join(",");
}

/**
 * Refuse a file before hashing or reserving anything. A browser that reports no
 * type, or an alias the tenant does not list, falls back to the extension's
 * canonical type, exactly as the published policy orders it. Without a
 * published policy the server alone decides.
 */
export function admitFile(policy: ArtifactUploadPolicy | null | undefined, file: File): { contentType: string } | { refusal: string } {
  if (!policy) return { contentType: file.type || "application/octet-stream" };
  if (file.size > policy.max_bytes) return { refusal: a3Copy.thisFileIsLargerThanChooseASmaller(megabytes(policy.max_bytes)) };
  const declared = file.type.toLowerCase();
  if (declared && policy.types.some(entry => entry.content_type === declared)) return { contentType: declared };
  const name = file.name.trim().toLowerCase(), dot = name.lastIndexOf(".");
  const suffix = dot > 0 ? name.slice(dot) : "";
  const known = suffix ? policy.types.find(entry => entry.extensions.includes(suffix)) : undefined;
  return known ? { contentType: known.content_type } : { refusal: a3Copy.imamAcceptsChooseAnotherFile(policy.summary) };
}
